import apiService from './api';
import type { ApiResponse } from '../types';

/** An active per-employee-per-period timesheet lock. */
export interface PeriodLock {
  id: number;
  user_id: number;
  period_start: string;
  period_end: string;
  locked_at: string;
  locked_by: number;
  locked_by_username?: string | null;
  reason: string | null;
}

class TimesheetLockService {
  /** Active locks across the org overlapping [start, end] (pay-cycle dashboard). */
  async getLocks(start: string, end: string): Promise<ApiResponse<PeriodLock[]>> {
    const qs = new URLSearchParams({ start, end }).toString();
    return apiService.get(`/timesheet/admin/locks?${qs}`);
  }

  /** Lock an employee's pay period (finalise for payroll). Idempotent. */
  async lockPeriod(data: {
    user_id: number;
    period_start: string;
    period_end: string;
    reason?: string;
  }): Promise<ApiResponse<PeriodLock>> {
    return apiService.post('/timesheet/approval/period-lock', data);
  }

  /** Reopen (unlock) a previously locked period by its lock id. */
  async unlockPeriod(lockId: number): Promise<ApiResponse<PeriodLock>> {
    return apiService.patch(`/timesheet/approval/period-lock/${lockId}/unlock`, {});
  }
}

export default new TimesheetLockService();
